import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { IconArrowLeft } from '@wds/icons';
import { T, t } from '@sm/intl';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { trackAmplitudeEvent } from '../lib';
import getStatus from './lib';
import { useGeneral } from '../Context';
export const COPY = {
  backButton: {
    id: 'OpenEndedCoding.TrainingFlow.backButton',
    defaultMessage: 'Back to all responses',
    description: '[Type: Header][Vis: med] - Back button keywords'
  },
  backLabel: {
    id: 'OpenEndedCoding.TrainingFlow.backLabel',
    defaultMessage: 'Back button',
    description: '[Type: Header][Vis: med] - Back button keywords'
  },
  looksGoodLabel: {
    id: 'OpenEndedCoding.TrainingFlow.looksGoodLabel',
    defaultMessage: 'Looks good?',
    description: '[Type: Header][Vis: med] - Ensure user is satisfied before proceeding with auto tagging'
  },
  startButton: {
    id: 'OpenEndedCoding.TrainingFlow.startButton',
    defaultMessage: 'Start auto-tagging',
    description: '[Type: Header][Vis: med] - Start auto tagging'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    footer: {
      display: 'flex',
      width: '100%',
      paddingY: theme.spacing[3],
      justifyContent: 'space-between'
    }
  };
});
const Footer = ({
  status,
  keywords,
  handleNext,
  onClose,
  hasInsufficientThemes
}) => {
  const classes = useStyles();
  const {
    surveyId,
    questionId,
    isSolutions
  } = useGeneral();
  const {
    isTagging,
    isDisabled,
    isTraining
  } = getStatus(status);
  const isError = keywords.filter(k => k.error).length > 0;
  return _jsxs(Box, {
    className: classes.footer,
    children: [_jsxs(Button, {
      label: t(COPY.backLabel),
      disabled: isTraining,
      variant: "text",
      color: "secondary",
      onClick: onClose,
      children: [_jsx(IconArrowLeft, {
        title: t(COPY.backLabel),
        size: "sm"
      }), _jsx(T, {
        desc: COPY.backButton
      })]
    }), _jsxs(Box, {
      display: "flex",
      alignItems: "center",
      children: [_jsx(Box, {
        mr: 4,
        children: !isTagging && _jsx(Typography, {
          children: _jsx(T, {
            desc: COPY.looksGoodLabel
          })
        })
      }), _jsx(Button, {
        "data-testid": "Footer__StartButton",
        disabled: isDisabled || isError || hasInsufficientThemes,
        onClick: () => {
          handleNext();
          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: isTagging ? 'open-ended coding viewed results' : 'open-ended coding started training',
            data: {
              surveyId,
              questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: _jsx(T, {
          desc: COPY.startButton
        })
      })]
    })]
  });
};
export default Footer;